import React from "react";
import Routes from "./routes";

const App = (props) => <Routes />;

export default App;
